(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["legacy-include-hub-content-tabs"] && !Shopify.designMode) return;
  try {
    /* Tab toggle behavior. Ported from Flextheme src/js/lib/components/content-tabs.js.
 * Adapted for Horizon:
 *  - Replaced `Shopify.media_queries.navxl.matches` with
 *    `window.matchMedia('(min-width: 1268px)')` (matches the CSS breakpoint).
 *  - IIFE wrapper (no ES module exports inside the javascript tag).
 *  - Re-initializes on `shopify:section:load` for Customizer live editing.
 *  - AbortController scoped per-section so listeners are released on
 *    `shopify:section:unload` (prevents leaks during Customizer reloads).
 *
 * NOTE: this is intentionally NOT a Web Component — see project memory note
 * "ZW-94 Polish PR Backlog" for the deferred refactor.
 */
(() => {
  'use strict';

  const desktopMQ = window.matchMedia('(min-width: 1268px)');
  const isHorizontalDisplay = () => desktopMQ.matches;

  const getSectionIdFromEvent = (e) => e.target.id.split('---')[0];

  const sectionControllers = new Map();

  const toggleContentDisplay = (e) => {
    const sectionId = getSectionIdFromEvent(e);
    const listEl = document.getElementById(`content-tabs-list-${sectionId}`);
    if (!listEl) return;
    const list = Array.from(listEl.children);
    const contentToDisplayIndex = list.indexOf(e.target.parentNode) + 1;

    for (let i = 0; i < list.length; i += 1) {
      if (!list[i].classList.contains('content-body')) continue;

      if (i === contentToDisplayIndex) {
        if (isHorizontalDisplay()) {
          list[i].classList.add('is-displayed');
          list[i].setAttribute('aria-expanded', 'true');
          list[i].tabIndex = 0;
          list[i - 1].setAttribute('aria-selected', 'true');
          list[i - 1].firstElementChild.checked = true;
        } else {
          list[i].classList.toggle('is-displayed');
          const expanded = list[i].getAttribute('aria-expanded') === 'true';
          list[i].setAttribute('aria-expanded', expanded ? 'false' : 'true');
          list[i].tabIndex = list[i].tabIndex === -1 ? 0 : -1;
          const selected = list[i - 1].getAttribute('aria-selected') === 'true';
          list[i - 1].setAttribute('aria-selected', selected ? 'false' : 'true');
        }
      } else if (isHorizontalDisplay()) {
        list[i].classList.remove('is-displayed');
        list[i].setAttribute('aria-expanded', 'false');
        list[i].tabIndex = 0;
        list[i - 1].firstElementChild.checked = false;
        list[i - 1].setAttribute('aria-selected', 'false');
      }
    }
  };

  const handleTabFocus = (e, offset) => {
    const sectionId = getSectionIdFromEvent(e);
    const labels = Array.from(
      document.querySelectorAll(`.content-tab-label-${sectionId}`)
    );
    const index = labels.indexOf(e.target) + offset;

    if (index < 0) {
      labels[labels.length - 1].focus();
    } else if (index >= labels.length) {
      labels[0].focus();
    } else {
      labels[index].focus();
    }
  };

  const handleTabKeydown = (e) => {
    switch (e.key) {
      case 'Enter':
        toggleContentDisplay(e);
        break;
      case 'ArrowLeft':
        handleTabFocus(e, -1);
        break;
      case 'ArrowRight':
        handleTabFocus(e, 1);
        break;
      default:
    }
  };

  const initializeContentTabs = (root) => {
    const scope = root || document;
    const tabs = scope.querySelectorAll('.content-tab');

    if (tabs.length === 0) return;

    // Resolve the section element this scope belongs to so we can
    // register an AbortController under its id and release it cleanly
    // on `shopify:section:unload`.
    const sectionEl = scope.closest
      ? scope.closest('[id^="shopify-section-"]')
      : null;
    const sectionKey = sectionEl ? sectionEl.id : 'global';

    sectionControllers.get(sectionKey)?.abort();
    const controller = new AbortController();
    sectionControllers.set(sectionKey, controller);
    const { signal } = controller;

    let openedFirst = false;
    for (const el of tabs) {
      if (el.dataset.contentTabsBound === '1') continue;
      el.dataset.contentTabsBound = '1';

      const tabInput = el.firstElementChild;
      if (!tabInput) continue;
      const tabLabel = tabInput.nextElementSibling;
      const openTab = tabInput.getAttribute('data-opentab') === 'open';

      tabInput.addEventListener('click', toggleContentDisplay, { signal });
      tabLabel?.addEventListener('keydown', handleTabKeydown, { signal });

      if (!openedFirst && (isHorizontalDisplay() || openTab)) {
        tabInput.click();
        openedFirst = true;
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeContentTabs());
  } else {
    initializeContentTabs();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeContentTabs(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    sectionControllers.get(event.target.id)?.abort();
    sectionControllers.delete(event.target.id);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
